import React, {useState} from 'react';
import styles from '../../styles/Dashboard/OnboardingCard.module.css';

const OnboardingCard = ({ setActiveView, setHighlightedSidebarItem }) => {
  // Example static state; replace with dynamic user data
  const steps = [
    { step: "Find Your Favoite Building", view: "tenant", sidebarKey: "tenant" },
    { step: "Set Up Roommate Group", view: "groups", sidebarKey: "groups" },
    { step: "Verify Documents", view: "documents", sidebarKey: "documents" },
  ];
  
  const [onboardingHover, setOnboardingHover] = useState(null);

  const nextStep = steps.find(step => !step.completed);

  return (
    <div className={styles.card}>
      <h2>👋 Welcome to MILO!</h2>
      <ul>
        {steps.map((item, idx) => (
		<li
		  key={idx}
		  onMouseEnter={() => {
			setHighlightedSidebarItem(item.sidebarKey);
			setOnboardingHover(item.sidebarKey);
		  }}
		  onMouseLeave={() => { setHighlightedSidebarItem(null); setOnboardingHover(null)}}
		  className={onboardingHover === item.sidebarKey ? styles.hovered : ''}
		>
		  {item.step}
		</li>

        ))}
      </ul>
    </div>
  );
};

export default OnboardingCard;
